"use strict";

var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

const HEADER = document.getElementById("header");

(() => {
	document.documentElement.style.setProperty("--header-height", `${HEADER.clientHeight + HEADER.offsetTop}px`);

	window.onload = () => {
		scrollW();
		window.addEventListener('scroll', scrollW);
	};

	// Split Primary Nav

	const primaryNav = document.getElementById("primary-nav");

	const tabletQuery = window.matchMedia('(min-width: 901px)');

	if (tabletQuery.matches) {
		const primaryNavList = primaryNav.firstElementChild;

		primaryNavList.removeAttribute("id");
		const mid = Math.ceil(primaryNavList.children.length / 2);

		const ul = document.createElement("ul");
		ul.className = "header__section flex-box always-flex";

		const primaryNavGroups = [
			[...primaryNavList.children].slice(0, mid),
			[...primaryNavList.children].slice(mid)
		];

		primaryNavList.remove();

		primaryNavGroups.forEach(group => {
			const clonedList = primaryNavList.cloneNode(false);
			clonedList.append(...group);

			const li = document.createElement("li");
			li.classList.add("header__half");
			li.append(clonedList);

			ul.append(li);
		});

		primaryNav.append(ul);
	} else {
		primaryNav.querySelectorAll(".submenu").forEach(submenu => {
			submenu.style.setProperty("--offset", `${submenu.scrollHeight + 10}px`);

			submenu.parentElement.addEventListener("click", function (e) {
				e.target === this && this.classList.toggle("active");
			});
		});
	}

	// Remove empty <p> tags created by TinyMCE

	document.querySelectorAll('p').forEach(e => {
		if (e.innerHTML.trim() === '') e.remove();
	});

	// Add custom arrows to lightboxes

	fetch(`${SITE_FILES}svg/arrow.svg`)
		.then(resp => resp.text())
		.then(data => {
			LBX._instances.forEach(lbx => {
				lbx.icons.prev = data;
				lbx.icons.next = data;
			});
		});

	// Split text into individual letter spans

	document.querySelectorAll(".title span, .form-module h2 span").forEach(element => {
		element.innerHTML = [...element.textContent].map(letter => letter === " " ? " " : `<i>${letter}</i>`).join("");
	});

	// ScrollTo Animation

	window.location.hash && animateTo(window.location.hash.substring(1));

	document.querySelectorAll('[href*="#"]:not([data-lbx]').forEach(cta => {
		let target = cta.hash.substring(1);

		if (!document.getElementById(target))
			return;

		cta.addEventListener("click", (e) => {
			e.preventDefault();
			animateTo(target);
		});
	});

	// Toggle Buttons

	document.querySelectorAll(".js-toggle").forEach(btn => {
		let target = document.getElementById(btn.dataset.target);

		if (!target)
			return;

		btn.addEventListener("click", (e) => {
			e.preventDefault();
			target.classList.toggle("active");
		});
	});

	let prevActiveEl;

	const toggleActiveObserver = new MutationObserver(mutationList => {
		mutationList.forEach(mutation => {
			const target = mutation.target;
			target.nextElementSibling.setAttribute("aria-expanded", target.classList.contains("active"));
		});
	});

	document.querySelectorAll(".js-toggle-active").forEach(element => {
		element.nextElementSibling.hasAttribute("aria-expanded") && toggleActiveObserver.observe(element, { attributes: true, attributeFilter: ["class"] });

		element.addEventListener("click", () => {
			prevActiveEl && prevActiveEl !== element && prevActiveEl.classList.remove("active");
			element.classList.toggle("active");
			prevActiveEl = element;
		});
	});

	// Set Up Animations

	addAnimations(".form-module", "top");
	addAnimations(".form-module h2");
	addAnimations(".text-modules", "top");
	addAnimations(".global-sitemap", "top");
	addAnimations(".attractions-content");

	// Custom functions

	document.querySelectorAll(".js-offset").forEach(element => {
		element.style.setProperty("--offset", `${element.scrollHeight}px`);
	});
})();

function scrollW() {
	const scrollTop = document.documentElement.scrollTop;

	if (scrollTop < 80) {
		HEADER.classList.remove('up', 'down');
	} else {
		HEADER.classList.toggle('down', scrollTop > lastScrollTop);
		HEADER.classList.toggle('up', scrollTop <= lastScrollTop);
	}

	lastScrollTop = Math.max(scrollTop, 0);  // Ensure lastScrollTop doesn't go below 0
}

function animateTo(target) {
	const toTarget = document.getElementById(target);

	if (!toTarget)
		return;

	const headerRects = (document.getElementById("header") || document.getElementsByTagName("header")[0]).getBoundingClientRect();
	const from = window.scrollY;
	const to = toTarget.getBoundingClientRect().top + from - (headerRects.height + headerRects.top);
	const duration = 1300;
	const start = performance.now();

	const easeInOutQuart = t => t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;

	function step(timestamp) {
		const time = timestamp - start;
		const progress = Math.min(time / duration, 1);
		const yH = easeInOutQuart(progress) * (to - from) + from;

		window.scrollTo(0, yH);

		time < duration && requestAnimationFrame(step);
	}

	requestAnimationFrame(step);
}

function addAnimations(selector, behavior = null) {
	for (const item of document.querySelectorAll(selector)) {
		item.classList.add("animate-fade", behavior);
	}
}